import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=6b4aedf4&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=js&"
export * from "./AccountInfo.vue?vue&type=script&lang=js&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=6b4aedf4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4aedf4",
  null
  
)

export default component.exports